import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import nb from './locales/nb.json'
import { TERM_DEFAULTS, normalizeLocale, setTerminologyVariables, toInterpolationVariables } from './terminology'

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nb: { translation: nb },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'nb'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'okr-language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
      // Locale strings name concepts with placeholders — "Create
      // {{objective}}", "No {{valueStreams, lower}} yet" — so a tenant's own
      // vocabulary reaches every sentence without any t() call site knowing
      // about it. TerminologyProvider replaces these once the tenant's terms
      // load; until then the built-in words are already correct, so nothing
      // flashes a raw placeholder on first paint.
      defaultVariables: toInterpolationVariables(
        TERM_DEFAULTS[normalizeLocale(i18next.language)],
        normalizeLocale(i18next.language),
      ),
    },
  })

// i18next ships number/currency/datetime/relativetime/list formatters and no
// case formatters, but a renameable term appears mid-sentence as often as it
// starts one. Terms are stored as the tenant capitalised them, so `lower` is
// what most sentences ask for and `title` restores a leading capital.
i18next.services.formatter?.add('lower', (value) =>
  typeof value === 'string' ? value.toLocaleLowerCase(i18next.language) : value,
)

i18next.services.formatter?.add('title', (value) =>
  typeof value === 'string' && value.length > 0
    ? value.charAt(0).toLocaleUpperCase(i18next.language) + value.slice(1)
    : value,
)

// `<html lang>` stayed "en" whatever the interface language, so a screen reader read Norwegian with
// English pronunciation and the browser offered to translate "from English" (F-88).
function syncDocumentLanguage(language: string | undefined) {
  if (typeof document === 'undefined' || !language) return
  document.documentElement.lang = normalizeLocale(language)
}
syncDocumentLanguage(i18next.language)
i18next.on('languageChanged', syncDocumentLanguage)

export { setTerminologyVariables }

export default i18next
